import { useMutation } from '@tanstack/react-query';
import * as assetServices from 'services/digitalAsset';

export const useRotateDigitalAsset = () =>
  useMutation({ mutationFn: assetServices.rotateDigitalAsset });
